import { FORTA_WHITE } from '../../utils/colors';

import type { IconProps } from './types';

function TimeTagStartIcon(props: IconProps) {
  const { color = FORTA_WHITE, width = 21, height = 17, viewBox = '0 0 21 17' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.5H20M20 8.5L13 1.5M20 8.5L13 15.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1 2.5L0.999999 14.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <line x1="4" y1="6.5" x2="4" y2="10.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default TimeTagStartIcon;
